// extracted by mini-css-extract-plugin
module.exports = {"interventionsList":"style__interventionsList__GWWLh"};